import { createSlice } from "@reduxjs/toolkit";
import {
  getSpecificationFoldersThunk,
  getSpecificationFolderDetailThunk,
  updateSpecificationFolderThunk,
  moveSpecificationFolderThunk,
  updateSpecificationFolderOrderThunk,
  getSpecificationFoldersThunkNoReload,
} from "../thunks/specificationFolderThunk";
import { ISpecificationFolderState } from "../types/specification-folder";

const initialState: ISpecificationFolderState = {
  folders: [],
  folderListResponse: null,
  folderList: [],
  currentFolder: null,
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  moveLoading: false,
  orderLoading: false,
  newlyCreatedFolderId: null,
  newlyCreatedFolderParentId: null,
};

export const specificationFolderSlice = createSlice({
  name: "specificationFolder",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearCurrentFolder: (state) => {
      state.currentFolder = null;
    },
    clearFolders: (state) => {
      state.folders = [];
      state.folderList = [];
    },
    setNewlyCreatedFolderId: (state, action) => {
      state.newlyCreatedFolderId = action.payload;
    },
    setNewlyCreatedFolderParentId: (state, action) => {
      state.newlyCreatedFolderParentId = action.payload;
    },
    clearNewlyCreatedFolderId: (state) => {
      state.newlyCreatedFolderId = null;
    },
    clearNewlyCreatedFolderParentId: (state) => {
      state.newlyCreatedFolderParentId = null;
    },
  },
  extraReducers: (builder) => {
    // Get Specification Folders
    builder
      .addCase(getSpecificationFoldersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecificationFoldersThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.folders = action.payload.data || [];
          state.folderListResponse = action.payload;
        }
      })
      .addCase(getSpecificationFoldersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(getSpecificationFoldersThunkNoReload.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(
        getSpecificationFoldersThunkNoReload.fulfilled,
        (state, action) => {
          // state.loading = false;
          if (action.payload?.success) {
            state.folders = action.payload.data || [];
            state.folderListResponse = action.payload;
          }
        }
      )
      .addCase(
        getSpecificationFoldersThunkNoReload.rejected,
        (state, action) => {
          // state.loading = false;
          state.error = action.payload as string;
        }
      );

    // Get Specification Folder Detail
    builder
      .addCase(getSpecificationFolderDetailThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpecificationFolderDetailThunk.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload?.success) {
          state.currentFolder = action.payload.data;
        }
      })
      .addCase(getSpecificationFolderDetailThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Update Specification Folder
    builder
      .addCase(updateSpecificationFolderThunk.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateSpecificationFolderThunk.fulfilled, (state, action) => {
        state.updateLoading = false;
        if (action.payload?.success) {
          const updatedFolder = action.payload.data;
          if (updatedFolder) {
            // Folders listesindeki klasörü güncelle
            const index = state.folders.findIndex(
              (folder) => folder.id === updatedFolder.id
            );
            if (index !== -1) {
              state.folders[index] = updatedFolder;
            }
            // Current folder'ı güncelle
            if (state.currentFolder?.id === updatedFolder.id) {
              state.currentFolder = updatedFolder;
            }
          }
        }
      })
      .addCase(updateSpecificationFolderThunk.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload as string;
      });

    // Move Specification Folder
    builder
      .addCase(moveSpecificationFolderThunk.pending, (state) => {
        state.moveLoading = true;
        state.error = null;
      })
      .addCase(moveSpecificationFolderThunk.fulfilled, (state) => {
        state.moveLoading = false;
      })
      .addCase(moveSpecificationFolderThunk.rejected, (state, action) => {
        state.moveLoading = false;
        state.error = action.payload as string;
      });

    // Update Specification Folder Order
    builder
      .addCase(updateSpecificationFolderOrderThunk.pending, (state) => {
        state.orderLoading = true;
        state.error = null;
      })
      .addCase(updateSpecificationFolderOrderThunk.fulfilled, (state) => {
        state.orderLoading = false;
      })
      .addCase(
        updateSpecificationFolderOrderThunk.rejected,
        (state, action) => {
          state.orderLoading = false;
          state.error = action.payload as string;
        }
      );
  },
});

export const {
  clearError,
  setLoading,
  clearCurrentFolder,
  clearFolders,
  setNewlyCreatedFolderId,
  clearNewlyCreatedFolderId,
  setNewlyCreatedFolderParentId,
  clearNewlyCreatedFolderParentId,
} = specificationFolderSlice.actions;
export default specificationFolderSlice.reducer;
